export var PSInternalTable;
(function (PSInternalTable) {
    PSInternalTable["DATA"] = "ps_data";
    PSInternalTable["CRUD"] = "ps_crud";
    PSInternalTable["BUCKETS"] = "ps_buckets";
    PSInternalTable["OPLOG"] = "ps_oplog";
    PSInternalTable["UNTYPED"] = "ps_untyped";
})(PSInternalTable || (PSInternalTable = {}));
export var PowerSyncControlCommand;
(function (PowerSyncControlCommand) {
    PowerSyncControlCommand["PROCESS_TEXT_LINE"] = "line_text";
    PowerSyncControlCommand["PROCESS_BSON_LINE"] = "line_binary";
    PowerSyncControlCommand["STOP"] = "stop";
    PowerSyncControlCommand["START"] = "start";
    PowerSyncControlCommand["NOTIFY_TOKEN_REFRESHED"] = "refreshed_token";
    PowerSyncControlCommand["NOTIFY_CRUD_UPLOAD_COMPLETED"] = "completed_upload";
    PowerSyncControlCommand["UPDATE_SUBSCRIPTIONS"] = "update_subscriptions";
    /**
     * An `established` or `end` event for response streams.
     */
    PowerSyncControlCommand["CONNECTION_STATE"] = "connection";
})(PowerSyncControlCommand || (PowerSyncControlCommand = {}));
/**
 * Invokes `powersync_control` from the core extension, casting the result to text.
 */
export async function rawPowerSyncControl(tx, op, payload) {
    // For some calls, notably on target_checkpoint_request_id, powersync_control returns a 64-bit integer we want to
    // represent as text. Instead of dealing with bigints which may or may not be supported across different sqlite
    // libraries, play it safe and cast to text before mapping to JavaScript.
    const { rawRows } = await tx.executeRaw('SELECT CAST(powersync_control(?, ?) AS TEXT)', [op, payload]);
    return rawRows[0][0];
}
/**
 * Reads the current target checkpoint request id, or updates it when the update parameter is set.
 *
 * After requesting a checkpoint, the service needs to include that checkpoint id (or a subsequent one) in a
 * `checkpoint_complete` message before we apply any subsequent sync lines. This guards against uploaded changes that
 * have not yet been synced to flicker if we apply an intermediate checkpoint.
 *
 * @param update An optional value to update the stored target checkpoint request. {@link MAX_OP_ID} can be used as a
 * sentinel for pending changes that have been uploaded, but for which no checkpoint request has been created yet.
 * @returns The previous checkpoint request.
 */
export function targetCheckpointRequestId(tx, update = null) {
    return rawPowerSyncControl(tx, 'target_checkpoint_request_id', update);
}
//# sourceMappingURL=BucketStorageAdapter.js.map